/**
 * [Search] 정렬기준 및 코드 현황
 * https://yanolja.atlassian.net/wiki/spaces/YASEARCH/pages/72450567
 */
export enum EN_PF_SEARCH_SORT_CODE {
  /**
   * 2: 순수 가까운 거리순
   * 기존에 존재하던 거리순(102)은 제휴여부, 숙소타입, placeAdPrice, 숙소ID 필드도
   * 정렬에 함께 사용하는데 반해 2는 오직 거리 오름차순으로만 정렬함
   */
  ONLY_DISTANCE_ORDER = 2,
  /** 100: 야놀자기본정렬 */
  YANOLJA_DEFAULT_ORDER = 100,
  /**
   * 101: 광고(프스베라) 제외
   * https://jira.yanolja.in/browse/CX-996
   */
  EXCLUDE_ADVERTISE = 101,
  /** 102: 거리순 */
  DISTANCE_ORDER = 102,
  /** 105: 가볼래요많은순 */
  FAVORITE_COUNT_DESCENDING = 105,
  /** 106: 지역기본정렬 */
  REGION_DEFAULT = 106,
  /** 107: 야놀자 추천순 */
  ARROUND_ORDER = 107,
  /** 123: 지역 예약가 높은순 > 숙박 예약가 내림차순 */
  AREA_RESERVE_PRICE_DESCENDING = 123,
  /** 124: 지역 예약가 낮은순 > 숙박 예약가 오름차순 */
  AREA_RESERVE_PRICE_ASCENDING = 124,
  /** 127: 내주변 예약가 높은순 > 숙박 예약가 내림차순 */
  AROUND_RESERVE_PRICE_DESCENDING = 127,
  /** 128: 내주변 예약가 낮은순 > 숙박 예약가 오름차순 */
  AROUND_RESERVE_PRICE_ASCENDING = 128,
  /** 131: 역주변 예약가 높은순 > 숙박 예약가 내림차순 */
  STATION_RESERVE_PRICE_DESCENDING = 131,
  /** 132: 역주변 예약가 낮은순 > 숙박 예약가 오름차순 */
  STATION_PRICE_ASCENDING = 132,
  /** 133: 후기 많은 순 */
  REVIEW_COUNT_DESCENDING = 133,
  /** 134: 후기 좋은 순 */
  REVIEW_SCORE_DESCENDING = 134,
  /** 300: 기획전 */
  EXHIBITION = 300,
}
